import Axios from "axios";

export default {
    namespaced: true,
    state: {
        categories: []
    },
    getters: {
        selectCategories: (state) => {
            const categories = [];
            for (const cate of state.categories) {
                categories.push({
                    text: cate.name,
                    value: cate.id
                });
            }
            return categories;
        }
    },
    mutations: {
        SET_CATEGORIES(state, categories) {
            state.categories = categories;
            const category = [];
            for (const cate of state.categories) {
                category.push({
                    text: cate.name,
                    value: cate.id
                });
            }
        }
    },
    actions: {
        async getCategories({
            commit
        }) {
            const {
                data
            } = await Axios.get('/lotto-category');

            if (data.success) {
                commit('SET_CATEGORIES', data.data);
            }

            return data;

        }
    }
}